module.exports = __webpack_public_path__ + "img/fplus-background.6e6db5fc.svg";